import getEventFileInput from './getEventFileInput';
import getOriginalEvent, { type TypeEventWithOriginalEvent } from './getOriginalEvent';

// ----------------------------------------------------------------------------

export type TypeClearInputEventLike = TypeEventWithOriginalEvent;

// ----------------------------------------------------------------------------

/*
 * Only the input branch survives an await. A DataTransfer is in read/write mode
 * for as long as its event is being dispatched and no longer, so clearing a drop
 * has to happen in the handler itself; called back from a promise — which is how
 * eventListener reaches this, after walking the folder — the two calls below are
 * no-ops the specification defines as such, not failures.
 */
function clearInputEvent(evt: TypeClearInputEventLike): void {
    const originalEvent = getOriginalEvent(evt);

    if (originalEvent instanceof DragEvent && originalEvent.dataTransfer) {
        originalEvent.dataTransfer.items.clear();
        originalEvent.dataTransfer.clearData();
    }

    if (!(originalEvent instanceof Event)) {
        return;
    }

    const input = getEventFileInput(originalEvent);

    if (input) {
        input.value = '';
    }
}

// ----------------------------------------------------------------------------

export default clearInputEvent;
